import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import JigsawGoogleAdPage from "./JigsawGoogleAdPage";
import SlidingGoogleAdPage from "./SlidingGoogleAdPage";
import WordWheelGoogleAdPage from "./WordWheelGoogleAdPage";

/**
 * Router for `/admin/advertisement/app-screenshot-links/google-ad/:app`.
 */
export default function AppGoogleAdPage() {
    const { app } = useParams();

    if (app === "word-wheel") {
        return <WordWheelGoogleAdPage />;
    }
    if (app === "jigsaw") {
        return <JigsawGoogleAdPage />;
    }
    if (app === "sliding") {
        return <SlidingGoogleAdPage />;
    }

    return (
        <Box sx={{ p: 3 }}>
            <Typography color="error">
                Google Ads page is not available for &quot;{app}&quot;. Use word-wheel, jigsaw, or
                sliding.
            </Typography>
        </Box>
    );
}
